/**
 * Compact "Last edited · 12m ago" label. Auto-refreshes every minute so
 * the relative time stays honest without any parent state.
 *
 * Falls back to the absolute date once the record is more than 24 hours
 * old — "3 days ago" feels vague after a while.
 */
import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

export default function LastEditedLabel({ updatedAt, prefix = "Last edited", className = "" }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((n) => n + 1), 60_000);
    return () => clearInterval(t);
  }, []);
  if (!updatedAt) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[11px] text-slate-400 ${className}`}
      title={new Date(updatedAt).toLocaleString()}
      data-testid="last-edited-label"
    >
      <Clock className="w-3 h-3" />
      {prefix} · {relative(updatedAt)}
    </span>
  );
}

function relative(iso) {
  const then = new Date(iso).getTime();
  if (isNaN(then)) return "";
  const s = Math.floor((Date.now() - then) / 1000);
  if (s < 45) return "just now";
  if (s < 60 * 60) return `${Math.floor(s / 60)}m ago`;
  if (s < 60 * 60 * 24) return `${Math.floor(s / 3600)}h ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
